import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import {
  OnboardFormStepEnum,
  OnboardingTabsEnum,
  selectCurrOnboardingTab,
  selectOnboardFormStep,
} from '../../onboardingSlice';
const tabTitleMap = {
  [OnboardingTabsEnum.customers]: 'Customer',
  [OnboardingTabsEnum.ranches]: 'Ranch',
  [OnboardingTabsEnum.blocks]: 'Block',
  [OnboardingTabsEnum.users]: 'User',
};

const stepTitleMap = {
  [OnboardFormStepEnum.Add]: 'Add',
  [OnboardFormStepEnum.Delete]: 'Delete',
  [OnboardFormStepEnum.Edit]: 'Edit',
  [OnboardFormStepEnum.View]: 'View',
};

const OnboardFormHeader: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const currTab = useAppSelector(selectCurrOnboardingTab);
  const onboardFormStep = useAppSelector(selectOnboardFormStep);

  const title = useMemo(() => {
    return `${stepTitleMap[onboardFormStep]} ${tabTitleMap[currTab]}`;
  }, [currTab, onboardFormStep]);

  return (
    <Box sx={{ width: '100%', color: theme.colors.common.white }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <Typography variant='h5'>{t(title, { ns: 'common' })}</Typography>
      </Box>
      <Divider sx={{ bgcolor: theme.colors.darkTheme.grey.muted }} />
    </Box>
  );
};

export default OnboardFormHeader;
